export default function Hero() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full h-screen min-h-[700px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/4b4055c4-1e9d-4e97-8d06-e41c79fbe298/c947b97c-b1af-44f7-a935-cfdb7e0ac350_moonseed2.png?v=17ec6577d8f1bc929af049178170ff81"
          alt="リラクゼーションサロン ムーンシード 内観"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-8">
        <div
          className="inline-flex items-center gap-2 text-white/80 text-xs tracking-[0.35em] mb-10 border border-white/30 px-5 py-2 rounded-full backdrop-blur-sm"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-white/70 inline-block" />
          完全個室・尼崎市のプライベートサロン
        </div>

        <h1
          className="text-white text-5xl md:text-6xl lg:text-7xl font-light leading-snug mb-6"
          style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.05em' }}
        >
          心と身体を
          <br />
          <span className="italic">解きほぐす</span>
        </h1>

        <p
          className="text-white/80 text-sm md:text-base tracking-widest mb-3"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          至福のひととき
        </p>

        <p
          className="text-white/65 text-xs md:text-sm tracking-wider mb-12 max-w-xl leading-relaxed"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          ヘッドスパ・フェイシャル・リンパマッサージ・よもぎ蒸し
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => handleScroll('#booking')}
            className="whitespace-nowrap bg-[#6b7c5c] hover:bg-[#5a6a4c] text-white text-sm tracking-[0.25em] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            ご予約はこちら
          </button>
          <button
            onClick={() => handleScroll('#services')}
            className="whitespace-nowrap border border-white/70 text-white text-sm tracking-[0.25em] px-10 py-4 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            施術メニュー
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
          <span className="text-xs tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            scroll
          </span>
          <div className="w-px h-10 bg-white/30 animate-pulse" />
        </div>
      </div>
    </section>
  );
}
